module.exports = __webpack_public_path__ + "static/media/ZCOOL Addict Italic-01.36b25b3e.svg";